import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../types';

export type TourStatus = 'not_started' | 'active' | 'skipped' | 'completed';

export interface TourState {
    activeTourId: string | null;
    stepIndex: number;
    run: boolean;
}

const initialState: TourState = {
    activeTourId: null,
    stepIndex: 0,
    run: false,
};

const tourSlice = createSlice({
    name: 'tour',
    initialState,
    reducers: {
        startTour: (state, action: PayloadAction<string>) => {
            state.activeTourId = action.payload;
            state.stepIndex = 0;
            state.run = true;
        },
        stopTour: (state) => {
            state.run = false;
        },
        setStepIndex: (state, action: PayloadAction<number>) => {
            state.stepIndex = action.payload;
        },
        advanceStep: (state) => {
            state.stepIndex += 1;
        },
        resetTour: (state) => {
            state.activeTourId = null;
            state.stepIndex = 0;
            state.run = false;
        },
        resumeTour: (state) => {
            state.run = true;
        },
    },
});

export const { startTour, stopTour, setStepIndex, advanceStep, resetTour, resumeTour } = tourSlice.actions;

export const selectTourRun = (state: RootState) => state.tour.run;
export const selectTourStepIndex = (state: RootState) => state.tour.stepIndex;
export const selectActiveTourId = (state: RootState) => state.tour.activeTourId;

export default tourSlice.reducer;
